const trimTrailingSlash = url => (url || '').replace(/\/$/, '');

export const getAuth0RedirectUri = () =>
  trimTrailingSlash(process.env.REACT_APP_AUTH0_REDIRECT_URI) ||
  trimTrailingSlash(process.env.REACT_APP_MARKETPLACE_ROOT_URL);

/**
 * Passwordless connection name in Auth0 (Authentication → Database / Passwordless).
 * Default `email` matches Auth0’s built-in Passwordless Email connection when enabled.
 */
export const getAuth0PasswordlessConnection = () => {
  const raw = process.env.REACT_APP_AUTH0_PASSWORDLESS_CONNECTION;
  const trimmed = typeof raw === 'string' ? raw.trim() : '';
  return trimmed || 'email';
};

/** True when Auth0ProviderMaybe will mount Auth0Provider (same rules as that component). */
export const hasAuth0EnvConfigured = () => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  const redirectUri = getAuth0RedirectUri();
  return !!(domain && clientId && redirectUri);
};

/**
 * When `true`, show email/password login and signup forms plus tabs.
 * When unset or any other value, and Auth0 env is configured, only the inline passwordless flow is shown (no tabs, no password fields).
 * If Auth0 is not configured, email/password UI is shown so the page is not empty.
 */
export const showEmailPasswordLogin = () =>
  String(process.env.REACT_APP_SHOW_EMAIL_PASSWORD_LOGIN || '').toLowerCase() === 'true';

/**
 * Auth0 hosted logout URL — clears the Auth0 session in the browser. Call after Sharetribe
 * `sdk.logout()` so Auth0FlexBridge does not immediately obtain a new ID token and re-login.
 * `returnTo` must be listed under Application → Allowed Logout URLs in Auth0.
 *
 * @param {string} returnTo - Absolute URL (e.g. https://app.example.com/login)
 * @returns {string|null}
 */
export const buildAuth0LogoutUrl = returnTo => {
  const domain = process.env.REACT_APP_AUTH0_DOMAIN;
  const clientId = process.env.REACT_APP_AUTH0_CLIENT_ID;
  if (!domain || !clientId || typeof returnTo !== 'string' || !returnTo) {
    return null;
  }
  const params = new URLSearchParams({
    client_id: clientId,
    returnTo,
  });
  return `https://${domain}/v2/logout?${params.toString()}`;
};

/**
 * Navigates to Auth0 logout. Returns true if navigation was started.
 * @param {string} returnTo - Absolute URL after logout
 */
export const redirectToAuth0Logout = returnTo => {
  const url = buildAuth0LogoutUrl(returnTo);
  if (!url || typeof window === 'undefined') {
    return false;
  }
  window.location.assign(url);
  return true;
};
